import React from 'react';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { ChakraV3 } from '..';
import { useDropArea } from '../hooks/useDropArea';
import type { FileUploadStatus } from '../hooks/useFileUpload';
import { FileInput } from './FileInput';

interface Props extends ChakraV3.StackProps {
  multiple: boolean;
  files: File[];
  accept?: string;
  status: FileUploadStatus;
  onFilesChange: (files: File[]) => void;
}

export const FileUploadControl = (props: Props) => {
  const { multiple, files, accept, status, onFilesChange, ...rest } = props;

  const [dropAreaProps, state] = useDropArea({
    onFiles: (files) => onFilesChange(files),
  });

  const styles = state.over
    ? {
        bg: 'purple.50',
        borderColor: 'purple.300',
      }
    : {
        bg: 'gray.50',
        borderColor: 'gray.300',
      };

  return (
    <ChakraV3.Stack
      {...dropAreaProps}
      {...styles}
      w='full'
      h='full'
      align='center'
      justify='center'
      padding={4}
      borderWidth='2px'
      borderRadius='8px'
      borderStyle='dashed'
      textAlign='center'
      {...rest}
    >
      <ChakraV3.Stack align='center' justify='center'>
        <ChakraV3.Icon fontSize={48} color='gray.400' display='unset'>
          <FaCloudUploadAlt />
        </ChakraV3.Icon>
        <ChakraV3.Text fontSize='xl' fontWeight='bold' color='gray.400'>
          Drag & Drop files here
        </ChakraV3.Text>
        <ChakraV3.Text fontSize='sm' fontWeight='bold' color='gray.400' mb='4' mt='2'>
          OR
        </ChakraV3.Text>
        <FileInput
          multiple={multiple}
          size='sm'
          colorPalette='brand'
          variant='solid'
          files={files}
          onFilesChange={onFilesChange}
          data-pw='browseFilesModalButton'
          accept={accept}
          loading={status === 'uploading'}
          loadingText='Uploading...'
        >
          Browse files
        </FileInput>
      </ChakraV3.Stack>
    </ChakraV3.Stack>
  );
};
